<template>
  <material-card
    v-if="selectedPlan !== null && selectedPlan !== undefined && planIdentity!==null && planIdentity!== undefined"
    :title="$t('components.contributionscontrol.termsetup.title')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="settings"
  >
    <template v-slot:actions>
      <div style="margin-right:20px">
        <no-autocomplete-textfield
          clearable
          v-model="searchValue"
          :label="$t('components.employers.search_employers_form.title')"
          append-icon="search"
        />
      </div>
    </template>
    <v-card-text>
      <v-container fill-height fluid>
        <v-row justify="center" class="pager-header">
          {{ $t("views.balanceview.pager_{0}_{1}", [currentPage, totalPages]) }}
        </v-row>
        <v-pagination
          v-model="currentPage"
          :length="totalPages"
          @input="next"
          v-show="false"
        ></v-pagination>

        <v-row justify="center">
          <v-btn
            @click="next(currentPage - 1)"
            text
            :disabled="currentPage === 1"
          >
            <v-icon style="font-size: 40px!important;font-weight: 600;">chevron_left</v-icon>
          </v-btn>
          <span style="margin-top:8px;font-size: 18px;font-weight: 500;">
            {{ translate2(pagerItem, "Name") }}
          </span>
          <v-btn
            @click="next(currentPage + 1)"
            text
            :disabled="currentPage === totalPages"
          >
            <v-icon style="font-size: 40px!important;font-weight: 600;">chevron_right</v-icon>
          </v-btn>
        </v-row>
        <v-row v-if="pagerItem !== null && pagerItem !== undefined">
          <v-col cols="12">
            <contribution-terms-setup-table
              v-if="pagerItem.EmployerContributionTerm.IsCustom"
              ref="table"
              :employer="pagerItem"
              @save-disabled="
                saveDisabled = $event.saveDisabled;
                discardDisabled = $event.discardDisabled;
              "
            />
            <pbas-data-table
              v-else-if="provider !== null && provider !== undefined"
              ref="table2"
              :dataProvider="provider"
              identifier="contributionsControlEmployersNoCustom"
              @error="error = $event"
              :showSelect="false"
              :sortBy="'StartDate'"
              :sortDescending="true"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions
      v-if="
        pagerItem !== null &&
          pagerItem !== undefined &&
          pagerItem.EmployerContributionTerm.IsCustom
      "
    >
      <!-- <v-btn
        text
        @click="
          $router.push({
            name: 'contributions',
            params: { planId: selectedPlan.Id },
          })
        "
      >
        {{ $t("globals.cancel") }}
      </v-btn> -->
      <v-btn
        text
        @click="discard"
        :disabled="discardDisabled"
        :loading="$refs.table ? $refs.table.saving : false"
      >
        {{ $t("components.memberimportsalaries.discard_changes") }}
      </v-btn>
      <v-btn
        color="primary"
        @click="save"
        :disabled="saveDisabled"
        :loading="$refs.table ? $refs.table.saving : false"
      >
        {{ $t("globals.save") }}
      </v-btn>
    </v-card-actions>
    <error-handler :error="error"></error-handler>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </material-card>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import ErrorHandler from "@/components/ErrorHandler";
import { mapActions, mapGetters } from "vuex";
import { ODataProvider, SortDirection } from "pbas-vue-components";
import ContributionTermsSetupTable from "./ContributionTermsSetupTable.vue";
// import TransSelect2 from "@/components/TransSelect2";
import { planSetter } from "@/mixins/planSetter";
import ContributionTermsHeaders from "@/headers/ContributionTerms";
import { translate2 } from "@/trans2";
import ContributionsControlEmployersHeaders from "@/headers/ContributionsControlEmployers";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield.vue";

export default {
  components: {
    ErrorHandler,
    // TransSelect2,
    ContributionTermsSetupTable,
    NoAutocompleteTextfield,
  },
  props: {},
  mixins: [planSetter],
  data: () => ({
    // valid: false,
    // model: {
    //   employer: undefined,
    // },
    // employers: [],
    error: null,
    show: true,
    discardDisabled: true,
    saveDisabled: true,
    provider: undefined,
    headers: [],
    term: null,
    pagerItem: null,
    pagerProvider: undefined,
    loading: false,
    currentPage: 0,
    itemsPerPage: 1,
    pagerFetchResult: {
      count: 0,
    },
    pagerHeaders: ContributionsControlEmployersHeaders,
    searchValue: undefined,
    searchMonitor: null,
    sortHeader: null,
  }),
  computed: {
    ...mapGetters("common", ["language"]),
    ...mapGetters("common", {
      selectedPlan: "plan",
    }),
    ...mapGetters("plansMembers", ["planIdentity"]),
    totalPages() {
      return Math.floor(this.pagerFetchResult.count / this.itemsPerPage);
    },
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
    pagerItem: {
      handler(v) {
        this.provider = undefined;
        if (v !== null && v !== undefined) {
          const url = `plans/${this.selectedPlan.Id}/employers-for-import/${
            v.Id
          }/contribution-terms`;
          this.$nextTick(() => {
            this.provider = new ODataProvider(
              this.$axiosHttp,
              url,
              this.headers
            );
          });
        }
      },
    },
    searchValue: {
      async handler(v) {
        if (v === null) {
          this.searchValue = undefined;
        }
        if (this.pagerProvider === null || this.pagerProvider === undefined) {
          return;
        }
        const obj = {};
        this.searchMonitor = obj;
        await this.delay(800);
        if (this.searchMonitor !== obj) {
          return;
        }
        this.currentPage = 1;
        this.getPagerItemsAsync();
      },
    },
  },
  mounted() {
    this.headers = ContributionTermsHeaders.filter(
      (o) => o.title !== "headers.contributionterms.completed"
    );
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    ...mapActions("plansMembers", ["getContributionControlEmployers"]),
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    translate2(item, property) {
      return translate2(item, property);
    },
    async loadPlanData() {
      this.pagerProvider = new ODataProvider(
        this.$axiosHttp,
        `plans/${
          this.selectedPlan.Id
        }/contributions-control/employers-for-import`,
        this.pagerHeaders
      );
      this.sortHeader = this.pagerHeaders.filter(
        (o) => o.title === "globals.name"
      )[0];
      this.currentPage = 1;
      this.getPagerItemsAsync();
      // this.loading = true;
      // try {
      //   this.employers = (await this.getContributionControlEmployers({
      //     planIdentityId: this.selectedPlan.Id,
      //   })).data.value;
      // } catch (error) {
      //   this.error = error;
      // } finally {
      //   this.loading = false;
      // }
    },
    save() {
      this.$refs.table.save();
    },
    discard() {
      this.$refs.table.discard();
    },
    next(page) {
      this.currentPage = page;
      this.getPagerItemsAsync();
    },
    async getPagerItemsAsync() {
      if (this.pagerProvider === undefined || this.pagerProvider === null) {
        return;
      }
      this.loading = true;
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const count = this.itemsPerPage;

      try {
        this.fetchingPromise = this.pagerProvider.fetchAsync(
          start,
          count,
          [{ header: this.sortHeader, direction: SortDirection.Ascending }],
          this.searchValue
        );
        const localPromise = this.fetchingPromise;

        const result = await localPromise;
        if (localPromise === this.fetchingPromise) {
          this.pagerFetchResult = result;
          this.pagerItem = this.pagerFetchResult.items[0];
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style scoped>
.previous-value-tooltip {
  margin-left: auto;
  margin-right: auto;
  margin-top: 10px;
  margin-bottom: 10px;
}
.v-tooltip__content {
  background-color: orange;
  max-width: fit-content !important;
  width: fit-content !important;
}
</style>
<style>
.pager-header {
  margin-bottom: 10px;
}
</style>
